export const formatFileSize = (bytes: string | number): string => {
  const numBytes = typeof bytes === 'string' ? parseInt(bytes, 10) : bytes

  if (isNaN(numBytes) || numBytes === 0) return '0 B'

  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(numBytes) / Math.log(k))

  return `${String(Math.round(numBytes / Math.pow(k, i)))} ${sizes[i]}`
}
